<template>
  <div>
    <div v-if="initLoading" class="text-center"><b-spinner/></div>
    <template v-else>
      <div class="text-right mb-3">
        <b-form-radio-group class="mb-2" v-model="viewMode" :options="viewOptions"></b-form-radio-group>
<!--        <b-form-radio-group v-if="viewMode === 'chart'" v-model="chartRangeMinutes" :options="chartRangeOptions" buttons button-variant="outline-primary"></b-form-radio-group>-->
      </div>
      <div v-if="viewMode === 'chart'" style="height: 600px;">
        <v-chart class="chart" :option="chartOptions"/>
      </div>
      <b-table v-if="viewMode === 'table'" ref="table" :items="uInfoData" small primary-key="logsDate" :fields="tableFields"></b-table>
    </template>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import { DateTime } from "luxon";
  import BaseComponent from "@/components/BaseComponent";
  import * as meetingService from "@/service/meetingService";
  import * as monitorService from "@/service/monitorService";
  import * as util from "@/service/util";
  import {BvTableFieldArray} from "bootstrap-vue";

  @Component
  export default class MonitorUser extends BaseComponent {

    @Prop({ required: true }) mid: string;
    @Prop({ required: true }) uid: string;
    @Prop({ required: true }) polling: boolean;

    alertMessage = "";
    initLoading = true;

    viewMode = "chart";
    viewOptions = [
      { text: this.$t("chartView").toString(), value: 'chart' },
      { text: this.$t("tableView").toString(), value: 'table' },
    ];

    chartRangeMinutes = 15;
    chartRangeOptions = [
      { text: "15m", value: 15 },
      { text: "30m", value: 30 },
      { text: "1h", value: 60 },
      { text: "2h", value: 120 },
      { text: "ALL", value: null },
    ];

    uInfoData = [];

    chartOptions = {
      legend: {
        top: 0,
      },
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        data: [],
      },
      yAxis: [
        {
          type: 'value',
          name: '',
          position: 'left',
          nameTextStyle: {
            fontWeight: "bold"
          }
        },
      ],
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          maxValueSpan: 2048,
        }
      ],
      grid: {
        top: 100,
      },
      series: [
        {
          name: "loss",
          type: 'line',
          data: []
        },
        {
          name: "jitter",
          type: 'line',
          data: []
        },
        {
          name: "rtt",
          type: 'line',
          data: []
        },
        {
          name: "asent",
          type: 'line',
          data: []
        },
        {
          name: "arec",
          type: 'line',
          data: []
        },
      ]
    };

    tableFields: BvTableFieldArray = [
      {
        key: "logsDate",
        label: "logsDate"
      },
      {
        key: "loss",
        label: "loss",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "jitter",
        label: "jitter",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "rtt",
        label: "rtt",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "asent",
        label: "asent",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "arec",
        label: "arec",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
      {
        key: "actions",
        label: "",
        thClass: "text-nowrap",
        thStyle: { width: "80px" },
        tdClass: "text-nowrap"
      },
    ];

    isDestroyed = false;

    mounted() {
      this.fetchMonitorUserInfoLoop();
    }

    async fetchMonitorUserInfoLoop() {
      do {
        try {
          const uInfoData = await monitorService.getMonitorUserInfo(this.mid, this.uid);
          this.setUInfoData(uInfoData);
          this.initLoading = false;

        } catch (e) {
          this.alertMessage = e.response?.data?.code || e.code;
        }
        await util.delay(5000);
      } while (this.polling && !this.isDestroyed);
    }

    setUInfoData(uInfoData: any[]) {
      // table
      this.uInfoData = uInfoData;

      // chart
      this.chartOptions.xAxis.data = uInfoData.map(it => DateTime.fromFormat(it.logsDate, "yyyy-MM-dd HH:mm:ss").toFormat("HH:mm:ss"));
      this.chartOptions.series[0].data = uInfoData.map(it => it.loss);
      this.chartOptions.series[1].data = uInfoData.map(it => it.jitter);
      this.chartOptions.series[2].data = uInfoData.map(it => it.rtt);
      this.chartOptions.series[3].data = uInfoData.map(it => it.asent);
      this.chartOptions.series[4].data = uInfoData.map(it => it.arec);
    }

    destroyed() {
      this.isDestroyed = true;
    }
  }
</script>
